export { default } from './SWSectionTariffCards';
